// extracted by mini-css-extract-plugin
module.exports = {"MyRewards":"RewardsBox_MyRewards__TMp_k"};